import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Play, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 500px
      setIsVisible(window.scrollY > 500);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-0 left-0 right-0 z-40 bg-[#0B1426]/95 backdrop-blur-lg border-t border-[#00B4D8]/20 py-3 px-4"
        >
          <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
            <div className="hidden sm:block">
              <p className="text-[#F8FAFC] font-medium">
                Transform your procurement in minutes
              </p>
              <p className="text-[#94A3B8] text-sm">
                No IT setup • Same-day insights • Free demo
              </p>
            </div>
            <div className="flex items-center gap-3 w-full sm:w-auto justify-center sm:justify-end">
              <Link to="/#demo">
                <Button 
                  variant="outline"
                  className="border-[#00B4D8] text-[#00B4D8] hover:bg-[#00B4D8]/10"
                  data-testid="sticky-try-demo-btn"
                >
                  <Play className="w-4 h-4 mr-2" />
                  Preview Platform
                </Button>
              </Link>
              <a href="mailto:info@procureaide.com">
                <Button 
                  className="bg-[#00B4D8] text-[#020617] font-bold hover:bg-[#0096B4]"
                  data-testid="sticky-book-demo-btn"
                >
                  Book Demo
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </a>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyCTA;
